
export const CUSTOMER_ID = 'customerId';

export const SPOT_ROOM_DISPLAY_NAME = 'spotRoomDisplayName';

export const SPOT_ROOM_ID = 'spotRoomId';

export const TENANT = 'tenant';
